import { displayText } from './helpers';
import { launchColors } from './launchTheme';

export const departmentKey = (name: string): string => name.replace(/\s+/g, ' ').trim().toLocaleUpperCase('sv');

export const departmentInitials = (name: string): string => {
  const words = displayText(name).toLocaleUpperCase('sv').split(/[^A-ZÅÄÖ0-9]+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2);
  return `${words[0][0]}${words[1][0]}`;
};

const palette = [
  { fg: launchColors.navy, bg: launchColors.softNavy },
  { fg: launchColors.petrolDark, bg: launchColors.petrolLight },
  { fg: launchColors.plumDark, bg: launchColors.plumLight },
  { fg: launchColors.mossDark, bg: launchColors.mossLight },
  { fg: launchColors.sandDark, bg: launchColors.sandLight },
  { fg: launchColors.warningText, bg: launchColors.warningBg },
];

export const departmentColor = (name: string): { fg: string; bg: string } => {
  const key = departmentKey(name);
  let hash = 0;
  for (let index = 0; index < key.length; index += 1) hash = (hash * 33 + key.charCodeAt(index)) >>> 0;
  return palette[hash % palette.length];
};

export const matchesDepartment = (roleText: string, departments: readonly string[]): boolean => {
  const key = departmentKey(roleText);
  return Boolean(key) && departments.some((item) => departmentKey(item) === key);
};
